import { schema } from 'normalizr';

import { processViewerIsFollowedByUser } from '../strategies/viewerIsFollowedByUser';

export const viewerIsFollowedByUserSchema: schema.Entity = new schema.Entity(
  'viewerIsFollowedByUsers',
  {},
  { processStrategy: processViewerIsFollowedByUser }
);

export type ViewerIsFollowedByUserEdgesSchema = typeof viewerIsFollowedByUserEdgesSchema;
export const viewerIsFollowedByUserEdgesSchema: schema.Object[] = [
  new schema.Object({ node: viewerIsFollowedByUserSchema }),
];
